<template>
  <div class="ccp">
    <div class="ccp-chips">
      <span v-for="p in value" :key="p.id" class="ccp-chip" :class="{ 'ccp-chip-off': p.isactive === false }">
        #{{ p.id }} {{ p.name }}
        <button type="button" class="ccp-x" title="Remove" @click="remove(p)">×</button>
      </span>
      <span v-if="!value.length" class="ccp-muted">No contact selected.</span>
    </div>
    <div class="ccp-search">
      <vs-input v-model="q" size="small" icon-pack="feather" icon="icon-search" class="w-full"
        placeholder="Search a contact: company, name, e-mail, VAT number or #id" @input="search" />
      <div v-if="results.length" class="ccp-results">
        <button v-for="r in results" :key="r.id" type="button" class="ccp-result" :disabled="isSelected(r)" @click="add(r)">
          <span class="ccp-strong">#{{ r.id }} {{ r.name }}</span>
          <span v-if="r.vat_number" class="ccp-muted">{{ r.vat_number }}</span>
          <span v-if="r.email" class="ccp-muted">{{ r.email }}</span>
          <span v-if="!r.isactive" class="ccp-tag">inactive</span>
          <span v-if="r.isbroker" class="ccp-tag">broker</span>
          <span v-if="isSelected(r)" class="ccp-tag">selected</span>
        </button>
      </div>
      <div v-else-if="searched && q.trim().length >= 2 && !searching" class="ccp-muted mt-1">No contact found.</div>
    </div>
  </div>
</template>

<script>
// Sélecteur de fiches people pour Client Access (v-model = [{ id, name }]).
// Liste de résultats en simple bloc (pas de v-select dans un tableau : cf. page FSC).
import axios from '@/axios.js'

export default {
  name: 'ContactPicker',
  props: {
    value: { type: Array, default: () => [] }
  },
  data () {
    return { q: '', results: [], searching: false, searched: false, timer: null, seq: 0 }
  },
  methods: {
    isSelected (r) {
      return this.value.some(p => p.id === r.id)
    },
    add (r) {
      if (this.isSelected(r)) return
      this.$emit('input', this.value.concat([{ id: r.id, name: r.name, isactive: r.isactive }]))
    },
    remove (p) {
      this.$emit('input', this.value.filter(x => x.id !== p.id))
    },
    search () {
      clearTimeout(this.timer)
      this.timer = setTimeout(this.run, 300)
    },
    async run () {
      const q = this.q.trim()
      if (q.length < 2) {
        this.results = []
        this.searched = false
        return
      }
      const seq = ++this.seq
      this.searching = true
      try {
        const res = await axios.get('/clientaccess/people', { params: { q } })
        if (seq === this.seq) this.results = res.data.people || []
      } catch (e) {
        if (seq === this.seq) this.results = []
      } finally {
        if (seq === this.seq) {
          this.searching = false
          this.searched = true
        }
      }
    }
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  }
}
</script>

<style scoped>
.ccp {
  display: grid;
  gap: 8px;
}
.ccp-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.ccp-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 4px 2px 10px;
  border-radius: 12px;
  background: #e8f5e9;
  color: #2e7d32;
  font-size: 0.75rem;
  font-weight: 600;
}
.ccp-chip-off {
  background: #f1f5f9;
  color: #64748b;
}
.ccp-x {
  border: none;
  background: transparent;
  color: inherit;
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
}
.ccp-results {
  display: grid;
  max-height: 260px;
  overflow-y: auto;
  margin-top: 4px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fff;
}
.ccp-result {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 10px;
  padding: 7px 10px;
  border: none;
  border-bottom: 1px solid #f1f5f9;
  background: #fff;
  font-size: 0.8125rem;
  text-align: left;
  cursor: pointer;
}
.ccp-result:hover:not(:disabled) {
  background: #f1f5f9;
}
.ccp-result:disabled {
  cursor: default;
  opacity: 0.6;
}
.ccp-strong {
  font-weight: 600;
}
.ccp-muted {
  color: #94a3b8;
  font-size: 0.75rem;
}
.ccp-tag {
  padding: 1px 6px;
  border-radius: 8px;
  background: #fff3e0;
  color: #e65100;
  font-size: 0.6875rem;
  font-weight: 600;
}
</style>
